import React from "react";
import { Clock, Sun, Moon } from "react-feather";
import { MAROON } from "../../../../components/common/brandColors";

/**
 * Now / Day / Night, ported from the Flutter dashboard's ShiftSelector.
 *
 * "Now" is not a cosmetic label - it is the ABSENCE of a shift parameter, which
 * lets the server resolve the running shift from its own configured changeover
 * times. Pinning Day or Night is what a manager does to look at a shift they are
 * not currently in (reviewing last night's marking over morning coffee).
 *
 * `nowShift` is what "Now" actually resolved to on the last response, shown on the
 * chip so the figures on screen are never ambiguous about what they describe.
 *
 * Lives in the guarding feature but is used by the dashboard widget too - both
 * must drive the same three states, and a second copy would drift.
 */
const OPTIONS = [
  { value: null, label: "Now", Icon: Clock },
  { value: "Day", label: "Day", Icon: Sun },
  { value: "Night", label: "Night", Icon: Moon },
];

// `showNow` is false when a past date is being viewed - "the running shift" means
// nothing for a day that is over, so Day or Night has to be picked.
const ShiftChips = ({ value = null, onChange, nowShift, size = "md", showNow = true }) => {
  const pad = size === "sm" ? "2px 9px" : "5px 13px";
  const font = size === "sm" ? 11.5 : 12.5;

  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      {OPTIONS.filter((o) => showNow || o.value !== null).map(({ value: optValue, label, Icon }) => {
        const isSelected = value === optValue;
        return (
          <button
            key={label}
            type="button"
            onClick={() => onChange(optValue)}
            style={{
              padding: pad,
              fontSize: font,
              fontWeight: 700,
              borderRadius: 999,
              background: isSelected ? MAROON : "transparent",
              color: isSelected ? "#fff" : "inherit",
              border: `1px solid ${isSelected ? MAROON : `${MAROON}4D`}`,
              lineHeight: 1.4,
            }}
          >
            <Icon size={13} className="me-1" style={{ verticalAlign: "-2px" }} />
            {/* Only the Now chip carries the resolved shift, and only while it is
                the selected one - on an unselected chip it would read as a claim
                about what is on screen, which it is not. */}
            {optValue === null && isSelected && nowShift ? `${label} · ${nowShift}` : label}
          </button>
        );
      })}
    </div>
  );
};

export default ShiftChips;
